export const LEXICAL = 'y';
export const SEMANTIC = 'z';
export const SENSE = 'Sense';
export const SENSE_KEY = '00';
export const WILDCARD = '*';
